import { ShapeProps } from '@features/powerpoint';
import { TextsOptions } from './texts';
import { theme } from '@features/executive-report/domain/theme';

const topAudienceShapeOptions = [
  {
    fill: {
      transparency: 78,
    },
    h: 2.22,
    w: 3.65,
    x: 0.69,
    y: 1.69,
  },
  {
    fill: {
      transparency: 87,
    },
    h: 1.82,
    w: 3.02,
    x: 4.58,
    y: 2.08,
  },
  {
    fill: {
      transparency: 84,
    },
    h: 1.94,
    w: 3.16,
    x: 1.18,
    y: 4.17,
  },
  {
    fill: {
      transparency: 95,
    },
    h: 1.64,
    w: 2.8,
    x: 4.58,
    y: 4.17,
  },
] as const satisfies readonly ShapeProps['options'][];

const topAudienceFillColorByIndex = (audienceIndex: number) =>
  audienceIndex < 2 ? theme.colors.inmarketGreen : theme.colors.lightGray;

const extraAudienceRectangle = (index: number): ShapeProps => ({
  shapeName: 'rect',
  options: {
    fill: {
      color: theme.colors.darkGray,
      transparency: 25,
    },
    h: 0.37,
    w: 3.98,
    x: 7.98,
    y: 2.35 + 0.5 * index,
  },
});

type ShapesOptions = Pick<TextsOptions, 'nameValuePairsByGroup'>;

export const shapes = (options: ShapesOptions): ShapeProps[] => {
  return [
    ...options.nameValuePairsByGroup.top.map(
      (_, audienceIndex): ShapeProps => ({
        shapeName: 'rect',
        options: {
          ...topAudienceShapeOptions[audienceIndex],
          fill: {
            ...topAudienceShapeOptions[audienceIndex]?.fill,
            color: topAudienceFillColorByIndex(audienceIndex),
          },
          x: topAudienceShapeOptions[audienceIndex]?.x,
        },
      })
    ),
    ...options.nameValuePairsByGroup.extra.map(
      (_, index): ShapeProps => extraAudienceRectangle(index)
    ),
  ];
};
